import { take, call, put, all } from "redux-saga/effects";
import * as api from "utils/api";
import A from "action-types";
import { errorMessage, message } from "actions/message";


export default function* root() {
    yield all([
        watchGetMasterIVRStates(),
        watchGetAllIVRStatesByCallSid(),
        watchGetAllIVRStatesByPatient(),
        watchStartCompletedIVRCallsToOrderConversion()
    ])
}
function* watchGetMasterIVRStates() {
    while (true) {
        const action = yield take(A.IVR.STATES.GET_MASTER)
        yield call(getMasterIVRStates, action)
    }
}

export function* getMasterIVRStates() {    
    try {       
        let response = yield call(api.get, "IVR/CallState/MasterList")      
        yield put(
            {
                type: A.IVR.STATES.RESPONSE_GET_MASTER,
                response
            }
        )   
        //yield put(message("Success! Got Your Question"))
    } catch (payload) {
        yield put(errorMessage("Sorry Could Not Retrieve Master IVR Table."));
    }
}


function* watchGetAllIVRStatesByCallSid() {
    while (true) {
        const action = yield take(A.IVR.STATES.GET_ALL_BY_CALLSID)
        yield call(getAllIVRStatesByCallSid, action)
    }
}

export function* getAllIVRStatesByCallSid(action) {
    const {payload: {callSid}} = action
    try {
        let response = yield call(api.get, `IVR/CallState/GetAllByCallSid/${callSid}`)
        yield put(
            {
                type: A.IVR.STATES.RESPONSE_GET_ALL_BY_CALLSID,
                response
            }
        )
        //yield put(message("Success! Got Your Question"))
    } catch (payload) {
        yield put(errorMessage("Sorry Could Not Retrieve Call IVR Table."));
    }
}

function* watchGetAllIVRStatesByPatient() {
    while (true) {
        const action = yield take(A.IVR.STATES.GET_ALL_BY_PATIENT)
        yield call(getAllIVRStatesByPatient, action)
    }
}

export function* getAllIVRStatesByPatient(action) {
    const { payload: { fkiPatient } } = action
    try {
        let response = yield call(api.get, `IVR/CallState/GetAllByPatient/${fkiPatient}`)
        yield put(
            {
                type: A.IVR.STATES.RESPONSE_GET_ALL_BY_PATIENT,
                response
            }
        )        
    } catch (payload) {
        yield put(errorMessage("Sorry Could Not Retrieve Patient IVR Table."));
    }
}


function* watchStartCompletedIVRCallsToOrderConversion() {
    while (true) {
        const action = yield take(A.IVR.STATES.START_COMPLETED_IVR_CALLS_TO_ORDERS_CONVERSION)
        yield call(startCompletedIVRCallsToOrderConversion, action)
    }
}

export function* startCompletedIVRCallsToOrderConversion() {
    try {
        yield call(api.put, `IVR/CreateOrders`)
        yield put(message("Success For IVR Call to Order Conversion"))
        yield put({
            type: "QUERY_REQUEST_DATA",
            payload: {
                query: {
                    pagination: {per: 15, page: 1 },
                    sort: {},
                    filters: {},
                    searches: {}
                },
                method: "PUT",
                route: "IVR/Calls",
                responseKey: "calls",
                entityKey: "ivrCallsMaster",
                idKey: "callSid"
            },
            meta: {
                apiId: "ivrCalls"
            }
        })
    } catch (payload) {
        yield put(errorMessage("Sorry there was an error in converting calls to orders"));
    }
}
